module.exports = __webpack_public_path__ + "static/media/addidas-logo-white.0c1819d8.svg";